import { CompressImage } from "../types";

export const getUnCompressedImages = (images: CompressImage[]) => {
    return images.filter((image) => !image.error && image.state !== "compressed");
};
